// Dismissable notice shown on phone-sized touch screens: the app works there,
// but the UI is built for tablets and desktops. Dismissal persists across
// visits. Tablets (coarse pointer, but a large enough viewport) never match.

import { useEffect, useState } from 'react'
import { useT } from '../i18n'
import { IconClose } from './icons'

const DISMISS_KEY = 'ventholes-mobile-notice-dismissed'

// Coarse pointer plus a phone-sized viewport in either orientation.
const PHONE_QUERY =
  '(pointer: coarse) and (max-width: 767px), (pointer: coarse) and (max-height: 500px)'

export function MobileNotice() {
  const t = useT()
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) !== null
    } catch {
      return false
    }
  })
  const [isPhone, setIsPhone] = useState(() => window.matchMedia(PHONE_QUERY).matches)

  // Track rotation and resize so the notice appears or leaves live.
  useEffect(() => {
    const mq = window.matchMedia(PHONE_QUERY)
    const onChange = (e: MediaQueryListEvent) => setIsPhone(e.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  if (dismissed || !isPhone) return null

  return (
    <div className="mobile-notice" role="note" aria-label="Small screen notice">
      <div className="mobile-notice-head">
        <span>{t('mobile.title', 'Small screen')}</span>
        <button
          className="quiet icon-btn"
          aria-label="Dismiss notice"
          onClick={() => {
            try {
              localStorage.setItem(DISMISS_KEY, '1')
            } catch {
              // Storage unavailable: the notice returns next launch, harmless.
            }
            setDismissed(true)
          }}
        >
          <IconClose size={12} />
        </button>
      </div>
      <div className="mobile-notice-body">
        {t(
          'mobile.body',
          'Ventholes is optimised for tablets and desktops. Everything works on a phone, but editing is cramped.',
        )}
      </div>
    </div>
  )
}
